import { render, staticRenderFns } from "./DeleteChildDeviceModal.vue?vue&type=template&id=7154edc4"
import script from "./DeleteChildDeviceModal.vue?vue&type=script&lang=ts"
export * from "./DeleteChildDeviceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports